import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Toaster } from '@/components/ui/toaster';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/components/Home';

function App() {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Helmet>
        <title>VegaVelox Analytech | High-Fidelity Fintech Engineering</title>
        <meta name="description" content="Surgical precision in fintech infrastructure and HFT-grade orchestration." />
      </Helmet>
      
      <div className="min-h-screen bg-[#1c1d21] text-foreground font-sans">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster />
      </div>
    </>
  );
}

export default App;